export const CircleSize = {
  REGULAR: 'Medium',
  LARGE: 'Large',
};
